import React from "react";
import gift1 from "../../../../assets/images/Event-2025/gift1.png";
import gift2 from "../../../../assets/images/Event-2025/gift2.png";
import gift3 from "../../../../assets/images/Event-2025/gift3.png";
import fireworks from "../../../../assets/images/Event-2025/fireworks.png";
import bgTopLeft from "../../../../assets/images/Event-2025/img-top-left.png";
import bgTopRight from "../../../../assets/images/Event-2025/img-top-right.png";
import moment from "moment";
import { useQuery } from "react-query";
import { ID_RANK_TABLE_EVENT_2024 } from "@config/constants/helper";
import { getRankNewYear2024 } from "dataLayer/user";
import { getHistoryEventNoel } from "dataLayer/product";

const page = 1;
const totalPage = 3;
export default function CongratulationMain({ isPageCongatulation }) {
  const { data: dataRank = {} } = useQuery(
    getRankNewYear2024(page, totalPage, ID_RANK_TABLE_EVENT_2024.rank)
  );
  const { data: historyEventNoel = {} } = useQuery(
    getHistoryEventNoel()
  );
  const ranksTop = dataRank?.ranks?.data || [];
  const resultSpeHis = historyEventNoel?.resultSpeHis || [];

  return (
    <div
      className={`instru_rank congratulation ${
        isPageCongatulation ? "page-cong" : ""
      }`}
    >
      <div className="congratu_content">
        <div className="congratu_left">
          <div className="congratu_left_winner">
            <h4>Ganadores de Navidad explosiva</h4>
            <div className="congratu_left_winner_list">
              <div className="congratu_left_winner_item">
                <div>
                  <p>1° premio</p>
                </div>
                <div>
                  <img src={gift1} alt="" />
                  <span>S/.1,500</span>
                </div>
                <div>
                  <p>{ranksTop[0]?.isdn || ""}</p>
                  <img className="img_firework" src={fireworks} alt="" />
                  <span className="num_firework">
                    {ranksTop[0]?.firework || ""}
                  </span>
                </div>
              </div>
              <div className="congratu_left_winner_item">
                <div>
                  <p>2° premio</p>
                </div>
                <div>
                  <img src={gift2} alt="" />
                  <span>Redmi 13 (S/. 1,399)</span>
                </div>
                <div>
                  <p>{ranksTop[1]?.isdn || ""}</p>
                  <img className="img_firework" src={fireworks} alt="" />
                  <span className="num_firework">
                    {ranksTop[1]?.firework || ""}
                  </span>
                </div>
              </div>
              <div className="congratu_left_winner_item">
                <div>
                  <p>3° premio</p>
                </div>
                <div>
                  <img src={gift3} alt="" />
                  <span>Redmi A3 (S/. 1,199)</span>
                </div>
                <div>
                  <p>{ranksTop[2]?.isdn || ""}</p>
                  <img className="img_firework" src={fireworks} alt="" />
                  <span className="num_firework">
                    {ranksTop[2]?.firework || ""}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="congratu_right">
          <h4>Ganadores de Gifcards de S/.100</h4>
          <div className="congratu_right_content">
            <ul>
              {resultSpeHis.map((item = {}) => {
                const datePart = item.open_time
                  ? moment(item.open_time).format("YYYY-MM-DD")
                  : "";
                const timePart = item.open_time
                  ? moment(item.open_time).format("HH:mm:ss")
                  : "";
                return (
                  <li className="li_winner" key={item.id}>
                    <p>{item.isdn}</p>
                    <p>
                      {datePart}&nbsp;{timePart}
                    </p>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
      {isPageCongatulation ? (
        <i className="footer-congaratu">
          ¡La Navidad Explosiva ha terminado! Desliza arriba para conocer a los ganadores y espera las próximas campañas de Bitel Subastas.
        </i>
      ) : null}

      <div className="bg_top_left">
        <img src={bgTopLeft} alt="" />
      </div>
      <div className="bg_top_right">
        <img src={bgTopRight} alt="" />
      </div>
    </div>
  );
}
